<template>
  <div class="fin-reg-dem">
    <!-- APRESENTA A OPÇÃO CARREGANDO NA TELA -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    
    <!-- APRESENTA O CONTEUDO DA TELA -->
    <template v-else>
      <div class="seletor">
        <!-- SETA O NOME DA DEMANDA -->
        <div v-if="demanda !== null" class="fin-reg-dem--demanda">
          <span v-html="demanda.demandaNome"></span>:
        </div>

        <!-- SETA O SELETOR DA DEMANDA -->
        <App-Select :data-time="time" class="app-cpnt-field fin-reg-dem--seletor" :class="campos.seletor.class"
        :cpntStatus='campos.seletor.status'
        :cpntId='campos.seletor.id'
        :cpntTabIndex='campos.seletor.tabIndex'
        :cpntNome='campos.seletor.nome'
        :cpntValue='campos.seletor.value'
        :cpntMensagem='campos.seletor.mensagem'
        :cpntMensagemTipo='campos.seletor.mensagemTipo'
        :cpntDisabled='campos.seletor.disabled'
        :cpntMostrar='campos.seletor.mostrar'
        :cpntExplica='campos.seletor.explica'
        :cpntPlaceholder='campos.seletor.placeholder'
        :cpntValueRef='campos.seletor.valueRef'
        :cpntRouter='campos.seletor.router'
        :cpntMethod='campos.seletor.method'
        :cpntField='campos.seletor.field'
        :cpntWhere='campos.seletor.where'
        :cpntAddButForm='campos.seletor.addButForm'
        :cpntKeyMostra='campos.seletor.keyMostra'
        :cpntTipoOrder='campos.seletor.tipoOrder'
        :cpntOrder='campos.seletor.order'
        :cpntOptions='campos.seletor.options'
        :cpntKeyValue='campos.seletor.keyValue'
        :cpntSearchMinimo='campos.seletor.searchMinimo'
        :cpntMask='campos.seletor.mask'
        :cpntOptionInicialNome='campos.seletor.optionInicialNome'
        :cpntOptionInicialValue='campos.seletor.optionInicialValue'
        :cpntNewOption='campos.seletor.newOption'
        
        :cpntOnBuscarOptions='campos.seletor.onBuscarOptions'
        :cpntOnChange='campos.seletor.onChange'
        :cpntOnBlur='campos.seletor.onBlur'
        :cpntOnRealizaBusca='campos.seletor.onRealizaBusca'
        :cpntOnKeyPressEnter='campos.seletor.onKeyPressEnter'
        ref="seletor"
        ></App-Select>

        <!-- SETA O BOTÃO DE EDITAR -->
        <App-Button v-if="demanda !== null" :cpntClass="[ 'btn', 'btn-warning', 'btn-sm', 'fin-reg-dem--botao' ]" @onClick="finRegDemandaEditarRegistro">
          Editar <span v-html="demanda.demandaNome"></span>
        </App-Button>
      </div>
      
      <!-- VERIFICA SE TEM ALGUM REGISTRO SELECIONADO -->
      <template v-if="demanda !== null">
        <!-- SETA A TELA PARA REGISTRAR NO FINANCEIRO -->
        <App-Financeiro-Registrar-Receita-Despesa v-if="demanda.fin_status === false" :data-time='time' :key="('dem_nome-' + demanda.demandaNome) + ('dem_cod-' + demanda.demandaId)"
        :cpntTipo="$route.params.demanda"
        :cpntRefId="demanda.demandaId"
        :cpntOnAtualizaDados='finRegDemandaAtualizarRegistro'
        ></App-Financeiro-Registrar-Receita-Despesa>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .fin-reg-dem {
    margin-top: 20px;
  }
    .fin-reg-dem > .seletor {
      width: 700px;
      margin: 0px auto;
      text-align: center;
    }
      .fin-reg-dem > .seletor > .fin-reg-dem--demanda {
        width: 100px;
        display: inline-block;
        text-align: right;
        margin-right: 5px;
      }
      .fin-reg-dem > .seletor > .fin-reg-dem--seletor {
        width: calc(100% - 210px);
        display: inline-block;
      }
      .fin-reg-dem > .seletor > .fin-reg-dem--botao {
        width: 100px;
        display: inline-block;
        margin-left: 5px;
      }
</style>

<style>
</style>

<script>
  export default {
    components: {
      'App-Financeiro-Registrar-Receita-Despesa': () => import('@/components/financeiro/Registrar/Financeiro-Registrar-Receita-Despesa.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          seletor: {
            id: this.cpntHashId + '--seletor',
            status: '',
            nome: '',
            keyValue: 'demandaId',
            keyMostra: [ '_demandaId', ' - ', 'vencimento_ptbr', ' - R$ ', '_valor', ' - ', 'nome', 'credito' ],
            options: [],
            apiEnv: 'seletor',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            newOption: false,
            onBuscarOptions: this.finRegDemandaBuscarValores,
            onChange: this.finRegDemandaOnChangeValue
          }
        },
        demanda: null
      }
    },
    mounted: function () {
      this.finRegDemandaIniciar()
    },
    methods: {
      finRegDemandaIniciar: function () {
        if ([ 'financeiro_registrar', 'financeiro_registrar_tipo_id', 'financeiro_registrar_tipo' ].indexOf(this.$route.name) !== -1) {
          // SETA O STATUS DA PAGINA
          this.finRegDemandaSetarStatusGeral('carregando')
          
          // VERIFICA SE TEM QUE ABRIR ALGUMA VENDA
          if ([ '', null, undefined ].indexOf(this.$route.params.id) === -1) {
            this.finRegDemandaBuscarValores(() => {
              // PEGA O OPTION SOLICITADO
              var option = this.campos.seletor.options.filter(item => item.demandaId === this.$route.params.id)

              // VERIFICA SE O REGISTRO EXISTE
              if (option.length === 0) {
                // RETORNA PARA TELA ANTERIOR
                this.$router.push({ name: 'financeiro_registrar_tipo', params: { tipo: this.$route.params.tipo, demanda: this.$route.params.demanda } })

                // APRESENTA MENSAGEM DE ERRO
                this.$store.state.msgWarn('WEB [406]: Registro não encontrado para registrar no financeiro.', 'warning')

                // LIMPA O STATUS DA TELA
                this.finRegDemandaSetarStatusGeral('')
              } else {
                // PEGA O VALOR ENCONTRADO
                option = option[0]

                // ALTERA O VALOR SELECIONADO
                this.finRegDemandaOnChangeValue(option, this.campos.seletor.id)

                // LIMPA O STATUS DA TELA
                this.finRegDemandaSetarStatusGeral('')
              }
            })
          } else {
            this.finRegDemandaSetarStatusGeral('')
          }
        }
      },
      finRegDemandaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegDemandaOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'class', '')

        switch (indexF[1]) {
          case 'seletor':
            // PEGA O VALOR RECEBIDO
            var valor = typeof value === 'string' ? { demandaId: '' } : value

            // SETA O STATUS FINANCEIRO
            valor.fin_status = false

            // SETA O VALOR DA DEMANDA RECEBIDA
            this.demanda = valor.demandaId === '' ? null : valor

            // LIMPA OS VALORES DO SELETOR
            if (this.demanda !== null) {
              this.campos.seletor.options = []
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finRegDemandaBuscarValores: function (callback) {
        // INICIA A VARIAVEL
        var router = ''
        var queryGet = ''

        // VERIFICA O CAMPO QUE DEVE BUSCAR
        switch (this.$route.params.tipo + '__' + this.$route.params.demanda) {
          case 'despesa__compra':
            // SETA O TIPO DE REGISTRO QUE DEVE BUSCAR
            queryGet = 'dem-compra'
            
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/financeiro/despesa/get/'
            break

          case 'receita__venda':
            // SETA O TIPO DE REGISTRO QUE DEVE BUSCAR
            queryGet = 'venda'
            
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/financeiro/receita/get/'
            break
        }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI(router, 'GET', queryGet, (retorno) => {
          for (var indexR in retorno.data) {
            // INICIA A VARIAVEL
            retorno.data[indexR].demandaId = ''
            retorno.data[indexR]._demandaId = ''
            retorno.data[indexR].demandaNome = ''

            // PEGA OS DADOS DA DEMANDA
            if ([ '', null, undefined ].indexOf(retorno.data[indexR].cod_venda) === -1) {
              // SETA O VALOR RECEBIDO
              retorno.data[indexR].demandaId = retorno.data[indexR].cod_venda

              // SETA O VALOR INICIAL DA VARIAVEL
              retorno.data[indexR]._demandaId = 'V'

              // SETA O NOME DA DEMANDA
              retorno.data[indexR].demandaNome = 'Venda'
            } else if ([ '', null, undefined ].indexOf(retorno.data[indexR].dem_compra) === -1) {
              // SETA O VALOR RECEBIDO
              retorno.data[indexR].demandaId = retorno.data[indexR].dem_compra

              // SETA O VALOR INICIAL DA VARIAVEL
              retorno.data[indexR]._demandaId = 'C'

              // SETA O NOME DA DEMANDA
              retorno.data[indexR].demandaNome = 'Compra'
            }

            // FORMATA O NUMERO RECEBIDO
            retorno.data[indexR]._demandaId += (retorno.data[indexR].demandaId.length <= 4 ? ('0000' + retorno.data[indexR].demandaId).slice(-4) : retorno.data[indexR].demandaId)

            // SETA O NOME DO CONTATO
            retorno.data[indexR].nome = (retorno.data[indexR].id_con_nome + ((retorno.data[indexR].id_con_pessoa === 'j' && retorno.data[indexR].id_con_empresa !== '') ? (' (' + retorno.data[indexR].id_con_empresa + ')') : '') + (retorno.data[indexR].id_con_status !== '1' ? ' <b>[Excluído]</b>' : ''))
            

            // FORMATA O VALOR RECEBIDO
            retorno.data[indexR]._valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[indexR].valor)

            // SETA O CREDITO DA VENDA
            retorno.data[indexR].credito = ''
            if ([ '', null, undefined, '0' ].indexOf(retorno.data[indexR].cre_dev) === -1) {
              retorno.data[indexR].credito = ' | POSSUI Uti. de Cré. (R$ ' + this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[indexR].cre_dev) + ')'
            }
          }

          // SETA OS VALORES RECEBIDOS
          this.campos.seletor.options = retorno.data

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // VERIFICA SE TEM RETORNO
          if (retorno.data.length === 0) {
            this.campos.seletor.onBuscarOptions = null
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }, this.finRegDemandaSetarStatusGeral)
      },
      finRegDemandaEditarRegistro: function () {
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'demanda_tipo_numero', params: { tipo: this.$route.params.demanda, id: this.demanda.demandaId } }).href, '_blank', {}, true)
      },
      finRegDemandaAtualizarRegistro: function () {
        // LIMPA OS VALORES DO SELETOR
        this.campos.seletor.options = []

        // SETA A FUNÇÃO DE BUSCA DE VALORES
        this.campos.seletor.onBuscarOptions = this.finRegDemandaBuscarValores

        // ATUALIZA O FLAG QUE FOI INSERIDO NO FINANCEIRO
        this.demanda.fin_status = true

        // ALTERA PARA OPÇÃO SELECIONE
        this.campos.seletor.value = ''

        // SETA OS DADOS A SEREM BUSCADOS
        this.$emit('FINANCEIRO_SETAR_PESQUISA', { demanda: this.$route.params.demanda, demandaId: this.demanda.demandaId })

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>